// Meta Pixel (Facebook/Instagram) helpers. The base pixel + initial PageView is
// loaded statically in client/index.html (pixel id 1337236414266495). These
// helpers fire client-side events for the React SPA. All calls no-op safely if
// the pixel script hasn't loaded (e.g. blocked by an ad blocker).
declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
  }
}

function fbq(...args: any[]): void {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq(...args);
  }
}

// Fire on every client-side route change (the initial load is tracked by the
// static pixel in index.html).
export function trackMetaPageView(): void {
  fbq("track", "PageView");
}

// Fire when the primary trial CTA is clicked on the /meta-trial landing page.
// Self-gated to /meta-trial so the shared homepage CTAs don't fire it elsewhere.
export function trackMetaTrialInitiateCheckout(): void {
  if (typeof window !== "undefined" && window.location.pathname === "/meta-trial") {
    fbq("track", "InitiateCheckout");
  }
}

// Fire once on a successful $1 trial signup (the Stripe success/thank-you route).
export function trackMetaTrialConversion(): void {
  fbq("track", "StartTrial", { value: 1.0, currency: "USD" });
  fbq("track", "Purchase", { value: 1.0, currency: "USD" });
}
